const selfServeRoutes = [
  {
    // Cart route
    path: '/:product/checkout',
    name: 'self-serve-checkout',
    component: () => import('@/components/archistar/selfserve/SelfServeCheckout.vue'),
    meta: {
      noAuthRequired: true
    }
  },
  {
    // Self enrol - Archistar
    path: '/enrol-archistar',
    name: 'enrol-archistar',
    component: () => import('@/components/archistar/selfserve/Enrol.vue'),
    props: {
      appId: 2,
      product: 'archistar'
    },
    meta: {
      noAuthRequired: true
    }
  },
  {
    // Self enrol - Academy
    path: '/enrol-academy',
    name: 'enrol-academy',
    component: () => import('@/components/archistar/selfserve/Enrol.vue'),
    props: {
      appId: 1,
      product: 'academy'
    },
    meta: {
      noAuthRequired: true
    }
  },
  {
    // Cart route
    path: '/:product/upgrades',
    name: 'self-serve-upgrades',
    component: () => import('@/components/archistar/selfserve/SelfServeUpgrades.vue')
  }
];

export default selfServeRoutes;
